import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
    lucideCalculator,
    lucideChevronDown,
    lucideClipboardList,
    lucideEye,
    lucideFiles,
    lucideGraduationCap,
    lucideHandshake,
    lucideHouse,
    lucideLayoutDashboard,
    lucideListTodo,
    lucideMail,
    lucideMapPinned,
    lucideNewspaper,
    lucideUsers,
} from '@ng-icons/lucide';
import { HlmCollapsibleImports } from '@spartan-ng/helm/collapsible';
import { HlmSidebarImports, HlmSidebarService } from '@spartan-ng/helm/sidebar';
import { HlmSkeletonImports } from '@spartan-ng/helm/skeleton';
import { map } from 'rxjs';
import { AuthMyService } from '../../auth/auth.service';
import { CompanyThemeService } from '../../utils/company-theme/company-theme.service';
import { AppNavigationService } from './app-navigation.service';
import { AppUserMenuComponent } from './app-user-menu.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app-sidebar.component.html',
    styleUrls: ['./app-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, RouterLink, NgIcon, HlmCollapsibleImports, HlmSidebarImports, HlmSkeletonImports, AppUserMenuComponent],
    providers: [
        provideIcons({
            lucideCalculator,
            lucideChevronDown,
            lucideClipboardList,
            lucideEye,
            lucideFiles,
            lucideGraduationCap,
            lucideHandshake,
            lucideHouse,
            lucideLayoutDashboard,
            lucideListTodo,
            lucideMail,
            lucideMapPinned,
            lucideNewspaper,
            lucideUsers,
        }),
    ],
})
export class AppSidebarComponent {
    protected readonly navigation = inject(AppNavigationService);
    protected readonly sidebar = inject(HlmSidebarService);
    protected readonly currentLogo$ = inject(CompanyThemeService).currentTheme$.pipe(map(theme => theme?.avatar || null));

    private readonly profile = toSignal(inject(AuthMyService).profile(), { initialValue: null });
    protected readonly isLoading = computed(() => this.profile() === null);
    protected readonly user = computed(() => this.profile()?.user ?? null);

    protected expandSidebarIfCollapsed(): void {
        if (!this.sidebar.isMobile() && this.sidebar.state() === 'collapsed') {
            this.sidebar.setOpen(true);
        }
    }

    protected onSubmenuClick(itemId: string): void {
        if (itemId === 'lists') {
            sessionStorage.removeItem('formValue');
        }
    }
}
